<template>
  <div class="back-navigation">
    <back-button :text="backButtonText" @click="handleBackBtnClick"></back-button>
  </div>
</template>

<script>

import BackButton from 'top20common/components/buttons/BackButton';
import {mapGetters} from 'vuex';

export default {
  props: {
    backButtonText: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters(['previousRoutePathState'])
  },
  methods: {
    handleBackBtnClick() {
      this.$router.push(`/${this.previousRoutePathState}`);
      this.$emit('click');
    }
  },
  components: {BackButton}
};
</script>
